import React from 'react';
import classNames from 'classnames';
import translate from '../_utils/tools/translate';
import PropTypes from 'prop-types';

const FavouritedFilters = ({
  handleFavouritesFilterCheck,
  favouritesFiltered,
}) => {
  return (
    <div className="m-1">
      <button
        className={classNames('btn favouritable shelf-filter-dropdown-toggle', {
          'btn-selected': favouritesFiltered,
        })}
        onClick={handleFavouritesFilterCheck}
        title={`See products with your ${translate('favourite')} design`}>
        <i
          className={
            favouritesFiltered
              ? 'selected fas fa-heart mr-2'
              : 'far fa-heart mr-1 text-dark'
          }
        />
        {`${translate('Favourites')}`}
      </button>
    </div>
  );
};

FavouritedFilters.propTypes = {
  handleFavouritesFilterCheck: PropTypes.func,
  favouritesFilters: PropTypes.bool,
};

export default FavouritedFilters;
